module.exports = __webpack_public_path__ + "static/media/sm-assess.db9f01db.svg";